module.exports = __webpack_public_path__ + "static/media/laser_reverse.e8d26c8.mp3";


//////////////////
// WEBPACK FOOTER
// ./src/assets/sound/laser_reverse.mp3
// module id = X1+w
// module chunks = 82